import React, { useContext } from 'react';
import { Container } from "@mui/material";
import { motion } from "framer-motion";
import { NavigationContext } from '../context/NavigationContext';

const variants = {
  enter: (direction = "next") => {
    return {
      y: direction === "next" ? 1000 : -1000,
      opacity: 0,
    };
  },
  center: {
    zIndex: 4,
    y: 0,
    opacity: 1,
  },
  exit: (direction = "next") => {
    return {
      zIndex: 4,
      y: direction === "back" ? 1000 : -1000,
      opacity: 0,
    };
  },
};

const CenteredPaper = ({ children }) => {
  const navigationContext = useContext(NavigationContext);
  
  return (
    <motion.main
      className="main__container"
      initial="enter"
      animate="center"
      exit="exit"
      custom={navigationContext.direction}
      transition={{
        y: { type: "tween", duration: 0.25 },
        opacity: { duration: 0.2 },
      }}
      variants={variants}
    >
      <div className="centered-paper">
        <div className="centered-paper-content-wrapper">
          {children}
        </div>
      </div>
    </motion.main>
  );
};

export default CenteredPaper;
